import React from 'react';

const ServiceCard = ({ title, description, image }) => (
  <div className="bg-[#055A6B] rounded-[20px] sm:rounded-[25px] lg:rounded-[40px] relative w-full max-w-[300px] sm:max-w-[360px] md:max-w-[420px] lg:max-w-[480px] h-[420px] sm:h-[480px] md:h-[540px] lg:h-[620px] overflow-hidden group mx-auto">
    {/* Title - Professional Services */}
    <div className="absolute left-[16px] sm:left-[24px] lg:left-[36px] top-[20px] sm:top-[28px] lg:top-[40px]">
      <h3 className="font-normal text-[20px] sm:text-[26px] md:text-[30px] lg:text-[36px] leading-[1.3] sm:leading-[1.4] lg:leading-[52px] text-[#E9E9E9]">
        {title}
      </h3>
    </div>
    
    {/* Line 2 - Divider */}
    <div className="absolute left-0 top-[68px] sm:top-[85px] lg:top-[115px] w-full h-0 border-t-[0.5px] border-[#9A9A9A]" />
    
    {/* Description */}
    <p className="absolute left-[16px] sm:left-[24px] lg:left-[36px] top-[85px] sm:top-[108px] lg:top-[145px] w-[85%] sm:w-[280px] lg:w-[350px] font-normal text-[13px] sm:text-[16px] md:text-[17px] lg:text-[20px] leading-[1.4] sm:leading-[1.5] lg:leading-[30px] text-white">
      {description}
    </p>
    
    {/* Arrow Icon - Vector button - bottom right of text area */}
    <div 
      className="absolute right-[20px] sm:right-[28px] lg:right-[35px] bottom-[20px] sm:bottom-[25px] lg:bottom-[30px] w-[35px] h-[35px] sm:w-[40px] sm:h-[40px] lg:w-[45px] lg:h-[45px] rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-transform z-20 bg-white"
    >
      <svg 
        className="w-[16px] h-[16px] sm:w-[18px] sm:h-[18px] lg:w-[20px] lg:h-[20px]"
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M7 17L17 7M17 7H7M17 7V17" 
          stroke="#F05736" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>

    {/* Frame 65 - Shadow layer */}
    <div className="absolute left-1/2 -translate-x-1/2 top-[180px] sm:top-[215px] lg:top-[265px] w-[85%] sm:w-[310px] lg:w-[395px] h-[160px] sm:h-[200px] lg:h-[265px] bg-[rgba(8,17,19,0.2)] rounded-[8px] sm:rounded-[10px]" />
    
    {/* Frame 66 - Middle layer */}
    <div className="absolute left-1/2 -translate-x-1/2 top-[200px] sm:top-[240px] lg:top-[290px] w-[90%] sm:w-[350px] lg:w-[445px] h-[180px] sm:h-[225px] lg:h-[295px] bg-[#173137] rounded-[15px] sm:rounded-[18px] lg:rounded-[20px]" />
    
    {/* Frame 64 - Main Image */}
    <div 
      className="absolute left-1/2 -translate-x-1/2 top-[220px] sm:top-[265px] lg:top-[320px] w-full h-[200px] sm:h-[215px] lg:h-[300px] bg-cover bg-center rounded-[20px] sm:rounded-[25px] lg:rounded-[40px] group-hover:scale-[1.02] transition-transform duration-300"
      style={{ backgroundImage: `url(${image})` }}
    />
  </div>
);

export default ServiceCard;
